var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FdSection',[_vm._v("Section 1")]),_c('FdSection',{directives:[{name:"bg",rawName:"v-bg:neutral-2",arg:"neutral-2"}]},[_vm._v("Section 2 with Background Color")]),_c('FdSection',[_vm._v("Section 3")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }